import { useTranslation } from "react-i18next";
import { useStyle } from "./style";
import { Avatar, Stack } from "@mui/material";
import { useRef } from "react";

const UploadImgProduct = ({
  productState,
  onChangeStateProduct,
  UploadProductImage,
}) => {
  const { classes } = useStyle();
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        UploadProductImage(productState?.id, e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };
  return (
    <div style={classes.itemOnFirstContainer}>
      <div style={classes.labelTitleStyle}>
        {t("products.addProduct.admin.uploadImg")}
      </div>
      <Stack
        style={classes.attachmentContainer}
        onClick={() => inputRef.current?.click()}
      >
        <Stack style={classes.attachmentStyle}>
          <Avatar
            sx={classes.avatar}
            src={`${productState.img}?${new Date().toString()}`}
          />
          <label style={classes.labelStyle}>
            {productState?.img
              ? t("products.addProduct.admin.imageUploaded")
              : t("mailingSettings.noAttachment")}
          </label>
        </Stack>
      </Stack>
      {/* <AddNewButton
        onClick={() => inputRef.current?.click()}
        label={t("mailingSettings.addNewAttachment")}
      /> */}
      <input
        type="file"
        accept=".jpg, .jpeg, .png, .gif, .svg"
        onChange={handleFileSelect}
        style={{ display: "none" }}
        ref={inputRef}
      />
    </div>
  );
};
export { UploadImgProduct };
